// extracted by mini-css-extract-plugin
export default {"scimToken":"SCIMTab-module__scimToken--WIwo6","regenerateToken":"SCIMTab-module__regenerateToken--YV7T0"};